_ = require 'underscore'
babble = require 'app/scripts/lib/babble'
l = require 'app/scripts/lib/localize'
protoExtend = require 'proto-extend'
xtend = require 'xtend'

stringifyValues = (obj) ->
  _.object([key, value.toString()] for own key, value of obj)

methods =
  format: ->
    @raw @l.apply(this, arguments)
    return

  # For use in cases where the <span> added by @raw won't work, e.g. inside
  # an option.  Note that any HTML in the translation is going to be escaped.
  formatText: ->
    @text @l.apply(this, arguments)

  classify: (hash) ->
    (key for key, value of hash when value).join(' ')

  urlify: (url) ->
    url = url
    .replace(/'/g, '\\\'')
    .replace(/"/g, '\\"')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)')
    "url('#{url}')"

  stylify: (hash) ->
    ("#{key}: #{value};" for key, value of hash when value).join('')

  addRecolorParam: (url, param) ->
    # only add the parameter if it's not a data url, because adding the
    # parameter to a data url will break the url. A data url can't respond to the
    # param anyway, of course
    if /^data:/.test url
      url
    else
      url + param

  optionSelected: (selected, props, body) ->
    if selected
      props = _.extend({ selected: 'selected' }, props)
    @option props, body

  check: (val, key) ->
    @format key
    @text ' '
    if val
      @icon 'check'
      @text ' '
    return

  icon: (name, textKey, properties = {}) ->
    if typeof textKey == 'object'
      properties = textKey
      textKey = undefined
    additionalClasses = properties.class ? ""
    props = xtend properties,
      class: "icon-sm icon-#{name} #{additionalClasses}".trim()
    @span props
    if textKey?
      @raw '&nbsp;'
      @format textKey
    return

module.exports = (t) ->
  base = protoExtend t, methods

  (name) ->
    protoExtend base,
      l: (key, args, options) ->
        key = babble.normalizeKeyPath(key)
        l(['templates', name, key...], stringifyValues(args), options)
